import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"

export class PaymentRepository {
    // 정산 내역 생성
    static onPostCreatePayment = (meetingId: string, params: any) => {
        return onRequest({
            url: `${getApiUrl('payments')}/${meetingId}/payments`,
            method: RequestMethod.POST,
            params
        })
    }

    // 정산 목록 조회
    static onGetPayments = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('payments')}/${meetingId}/payments`,
            method: RequestMethod.GET
        })
    }

    // 정산 상세 조회
    static onGetPaymentDetail = (paymentId: string) => {
        return onRequest({
            url: `${getApiUrl('paymentDetail')}/${paymentId}`,
            method: RequestMethod.GET
        })
    }

    // 지출 수정 (작성자만 가능)
    static onPutUpdatePayment = (paymentId: string, params: any) => {
        return onRequest({
            url: `${getApiUrl('paymentDetail')}/${paymentId}`,
            method: RequestMethod.PUT,
            params
        })
    }

    // 지출 삭제 (작성자만 가능, soft delete)
    static onDeletePayment = (paymentId: string) => {
        return onRequest({
            url: `${getApiUrl('paymentDetail')}/${paymentId}`,
            method: RequestMethod.DELETE
        })
    }

    // 정산 요청 (현재 API에 없음 - 나중에 구현 필요)
    static onPostRequestPayment = (paymentId: string, params?: any) => {
        return onRequest({
            url: `${getApiUrl('paymentRequest')}/${paymentId}/request`,
            method: RequestMethod.POST,
            params
        })
    }

    // 정산 완료(받았어요) — 결제자 수신 확인 (params.splitId 로 특정 송금자 지정 가능)
    static onPostCompletePayment = (paymentId: string, params?: any) => {
        return onRequest({
            url: `${getApiUrl('paymentComplete')}/${paymentId}/complete`,
            method: RequestMethod.POST,
            params
        })
    }

    // 송금자 측 "보냈어요" 체크 — 본인 split 에 is_sent=TRUE 기록 (리마인더 중단)
    static onPostMarkSent = (paymentId: string) => {
        return onRequest({
            url: `${getApiUrl('paymentComplete')}/${paymentId}/sent`,
            method: RequestMethod.POST
        })
    }

    // 송금자 측 "보냈어요" 취소 — 잘못 체크한 경우 되돌림. 수신자가 받았어요 처리한 건은 거부됨.
    static onPostMarkUnsent = (paymentId: string) => {
        return onRequest({
            url: `${getApiUrl('paymentComplete')}/${paymentId}/sent/cancel`,
            method: RequestMethod.POST
        })
    }

    // 정산 재촉(nudge) — 결제자가 미송금 split 의 송금자에게 푸시 1회. 24h 쿨다운.
    // 응답 data: { ok, cooldownActive, nextAvailableAt }
    static onPostRemindSplit = (paymentId: string, splitId: number) => {
        return onRequest({
            url: `${getApiUrl('paymentComplete')}/${paymentId}/splits/${splitId}/remind`,
            method: RequestMethod.POST
        })
    }

    // 외부 인원 목록 조회
    static onGetExternalMembers = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('payments')}/${meetingId}/externals`,
            method: RequestMethod.GET
        })
    }

    // 외부 인원 추가
    static onPostCreateExternalMember = (meetingId: string, name: string) => {
        return onRequest({
            url: `${getApiUrl('payments')}/${meetingId}/externals`,
            method: RequestMethod.POST,
            params: { name }
        })
    }

    // 외부 인원 삭제
    static onDeleteExternalMember = (meetingId: string, externalNo: number) => {
        return onRequest({
            url: `${getApiUrl('payments')}/${meetingId}/externals/${externalNo}`,
            method: RequestMethod.DELETE
        })
    }

    // 영수증 이미지 업로드 (wiz-common R2) — fileUrl 받음. category=RECEIPT 로 분류.
    static onUploadReceiptImage = (file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('category', 'RECEIPT');
        return onRequest({
            url: getApiUrl('fileUpload'),
            method: RequestMethod.POST,
            params: formData,
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    }

    // 영수증 OCR 분석 (wizai PaddleOCR) — Gateway 경유, 사용자 JWT 로 통과
    static onAnalyzeReceipt = (imageUrl: string) => {
        return onRequest({
            url: getApiUrl('wizaiReceiptAnalyze'),
            method: RequestMethod.POST,
            params: { image_url: imageUrl }
        })
    }
}
